import { render, staticRenderFns } from "./Reauthorize2.vue?vue&type=template&id=1e8c3972&scoped=true&"
import script from "./Reauthorize2.vue?vue&type=script&lang=js&"
export * from "./Reauthorize2.vue?vue&type=script&lang=js&"
import style0 from "./Reauthorize2.vue?vue&type=style&index=0&id=1e8c3972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c3972",
  null
  
)

export default component.exports